import { render, staticRenderFns } from "./CompWindow.vue?vue&type=template&id=75b953c4&scoped=true&"
import script from "./CompWindow.vue?vue&type=script&lang=js&"
export * from "./CompWindow.vue?vue&type=script&lang=js&"
import style0 from "./CompWindow.vue?vue&type=style&index=0&id=75b953c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b953c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
